const MAX_DOLLARS = 5

export type DollarRatingProps = {
  /**
   * Ribbon `efficiencyIndex` on a 1–5 scale (higher = more cost-efficient /
   * cheaper). Rendered inverted so it reads like a price: `efficiencyIndex` is
   * higher = better value (cheaper), but `$$$$$` universally means expensive —
   * so the most efficient provider shows the *fewest* `$`.
   */
  efficiencyIndex: number
  className?: string
}

export const DollarRating = ({ efficiencyIndex, className }: DollarRatingProps) => {
  // efficiencyIndex: 1 (least efficient / most expensive) … 5 (most efficient /
  // cheapest). Invert so the cheapest provider shows the fewest $ — $$$$$ reads
  // as expensive. 5 → $, 1 → $$$$$.
  const clampedIndex = Math.min(MAX_DOLLARS, Math.max(1, Math.round(efficiencyIndex)))
  const filledCount = MAX_DOLLARS + 1 - clampedIndex

  return (
    <div
      className={['inline-flex items-center gap-0.5', className].filter(Boolean).join(' ')}
      role="img"
      aria-label={`${filledCount} out of ${MAX_DOLLARS} dollar signs`}
      data-testid="dollar-rating"
    >
      {Array.from({ length: MAX_DOLLARS }, (_, index) => {
        const filled = index < filledCount
        return (
          <span
            // biome-ignore lint/suspicious/noArrayIndexKey: dollar glyphs are identical static icons
            key={index}
            className={filled ? 'text-secondary-800' : 'text-secondary-300'}
            data-testid={filled ? 'dollar-rating-filled' : 'dollar-rating-muted'}
            aria-hidden="true"
          >
            $
          </span>
        )
      })}
    </div>
  )
}
